import React from 'react';

function BarMessengerIcon(props: JSX.IntrinsicElements['svg']) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      {...props}>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <path
              d="M0 0H30V30H0z"
              transform="translate(-1465 -681) translate(1465 681)"
            />
            <path
              fill="#3DB2FF"
              d="M16.895 20.294L12.187 15.242 3 20.294 13.105 9.5 17.928 14.553 27 9.5z"
              transform="translate(-1465 -681) translate(1465 681)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default BarMessengerIcon;
